import {
  LayoutDashboard, UserCircle, Users, ShieldCheck, Package,
  Receipt, BarChart3, TrendingUp, ScrollText, Bell,
  HelpCircle, MessageSquare, Settings,
  HeadphonesIcon, Crown, Mail, FileText,
  KeyRound, DatabaseBackup, GitCommitHorizontal, Lock, Calendar, Trophy, StickyNote,Server 
} from 'lucide-react'

export const NAV_GROUPS = [
  {
    label: 'Main',
    items: [
      { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
      { path: '/admin-profile', label: 'Admin Profile', icon: UserCircle },
    ],
  },
  {
    label: 'User Management',
    items: [
      { path: '/user', label: 'Users', icon: Users },
      { path: '/sub-admin', label: 'Sub Admin', icon: ShieldCheck },
      { path: '/roles', label: 'Roles & Permissions', icon: Lock },
    ],
  },
  {
    label: 'Business Management',
    items: [
      { path: '/item-management', label: 'Item Management', icon: Package },
      { path: '/transaction', label: 'Transactions', icon: Receipt },
      { path: '/subscription', label: 'Subscriptions', icon: Crown },
      { path: '/invoice', label: 'Invoices', icon: FileText },
      { path: '/rewards', label: 'Rewards', icon: Trophy },
    ],
  },
  {
    label: 'Planning',
    items: [
      { path: '/calendar', label: 'Events', icon: Calendar },
      { path: '/notes', label: 'Notes', icon: StickyNote },
    ],
  },
  {
    label: 'Analytics',
    items: [
      { path: '/analytics', label: 'Analytics', icon: TrendingUp },
      { path: '/report', label: 'Reports', icon: BarChart3 },
      { path: '/system-logs', label: 'System Logs', icon: Server  },
      { path: '/activity-logs', label: 'Activity Logs', icon: ScrollText },
    ],
  },
  {
    label: 'Communication',
    items: [
      { path: '/push-notification', label: 'Notifications', icon: Bell },
      { path: '/email-center', label: 'Email', icon: Mail },
      { path: '/support', label: 'Support', icon: HeadphonesIcon },

    ],
  },
  {
    label: 'System',
    items: [
      { path: '/faqs', label: 'FAQs', icon: HelpCircle },
      { path: '/feedback', label: 'Feedback', icon: MessageSquare },
      { path: '/setting', label: 'Settings', icon: Settings },
    ],
  },
]

export const ROUTE_META = NAV_GROUPS.reduce((acc, group) => {
  group.items.forEach((item) => {
    acc[item.path] = { title: item.label, parent: group.label }
  })
  return acc
}, {})